/*
 * @version: V1.0.0
 * @Date: 2023-11-02 18:00:37
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-23 16:11:31
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\antiFake\supervisor.js
 * @Descripttion:
 */
import request from '@/utils/request'

// 获取监管员列表
export function getSupervisorList(params) {
  return request({
    url: '/appletSupervisor/list',
    method: 'get',
    params,
    headers: {
      isApplet: true
    }
  })
}
// 修改或新增监管员
export function addSupervisor(data) {
  return request({
    url: '/appletSupervisor',
    method: 'post',
    data,
    headers: {
      isApplet: true
    }
  })
}
// 修改或新增监管员
export function updateSupervisor(data) {
  return request({
    url: '/appletSupervisor',
    method: 'put',
    data,
    headers: {
      isApplet: true
    }
  })
}

export function deleteSupervisor(ids) {
  return request({
    url: `/appletSupervisor/${ids}`,
    method: 'delete',
    headers: {
      isApplet: true
    }
  })
}
